import { useTranslation } from "react-i18next";

export default function Testimonials() {
  const { t } = useTranslation();

  const reviews = [
    {
      nameKey: "testimonial.1.name",
      textKey: "testimonial.1.text",
      img: "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20young%20European%20woman%20with%20warm%20smile%2C%20clean%20cream%20background%2C%20soft%20natural%20lighting%2C%20minimalist%20editorial%20style%2C%20neutral%20warm%20tones%2C%20elegant%20casual%20attire%2C%20friendly%20expression&width=400&height=400&seq=test-avatar-1-v2&orientation=squarish",
    },
    {
      nameKey: "testimonial.2.name",
      textKey: "testimonial.2.text",
      img: "https://readdy.ai/api/search-image?query=Portrait%20of%20young%20European%20man%20with%20confident%20expression%2C%20clean%20cream%20background%2C%20soft%20natural%20lighting%2C%20minimalist%20editorial%20photography%2C%20neutral%20warm%20tones%2C%20casual%20stylish%20outfit%2C%20professional%20yet%20approachable%20look&width=400&height=400&seq=test-avatar-2-v2&orientation=squarish",
    },
    {
      nameKey: "testimonial.3.name",
      textKey: "testimonial.3.text",
      img: "https://readdy.ai/api/search-image?query=Elegant%20portrait%20of%20young%20Polish%20woman%20with%20gentle%20smile%2C%20clean%20cream%20background%2C%20soft%20natural%20lighting%2C%20minimalist%20editorial%20style%2C%20neutral%20warm%20tones%2C%20simple%20fashionable%20clothing%2C%20friendly%20warm%20expression&width=400&height=400&seq=test-avatar-3-v2&orientation=squarish",
    },
    {
      nameKey: "testimonial.4.name",
      textKey: "testimonial.4.text",
      img: "https://readdy.ai/api/search-image?query=Portrait%20of%20European%20man%20with%20friendly%20expression%2C%20clean%20cream%20background%2C%20soft%20diffused%20lighting%2C%20minimalist%20editorial%20photography%2C%20neutral%20warm%20tones%2C%20smart%20casual%20attire%2C%20authentic%20approachable%20look&width=400&height=400&seq=test-avatar-4-v2&orientation=squarish",
    },
    {
      nameKey: "testimonial.5.name",
      textKey: "testimonial.5.text",
      img: "https://readdy.ai/api/search-image?query=Warm%20portrait%20of%20young%20Polish%20woman%20with%20bright%20smile%2C%20clean%20cream%20background%2C%20soft%20natural%20lighting%2C%20minimalist%20editorial%20style%2C%20neutral%20warm%20tones%2C%20stylish%20modern%20outfit%2C%20genuine%20happy%20expression&width=400&height=400&seq=test-avatar-5-v2&orientation=squarish",
    },
  ];

  return (
    <section className="bg-background-50">
      <div className="px-4 md:px-6 py-14 md:py-20">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-flex items-center gap-1.5 text-accent-500 text-xs font-semibold mb-3 whitespace-nowrap">
            <i className="ri-double-quotes-l text-base"></i>
            Opinie
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 leading-tight">
            {t("testimonials.title")}
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base">
            {t("testimonials.subtitle")}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {reviews.slice(0, 2).map((review) => (
            <div
              key={review.nameKey}
              className="p-5 md:p-6 rounded-lg bg-background-100 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={review.img}
                    alt={t(review.nameKey)}
                    className="w-full h-full object-cover"
                  />
                </div>
                <p className="text-sm font-semibold text-foreground-900 whitespace-nowrap">
                  {t(review.nameKey)}
                </p>
              </div>
              <i className="ri-double-quotes-l text-accent-300 text-xl mb-2 block"></i>
              <p className="text-foreground-600 text-sm leading-relaxed">
                {t(review.textKey)}
              </p>
            </div>
          ))}

          <div
            className="relative rounded-lg overflow-hidden group"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Fashionable%20young%20European%20couple%20sharing%20warm%20genuine%20moment%2C%20clean%20cream%20studio%20background%2C%20soft%20natural%20lighting%2C%20editorial%20lifestyle%20photography%2C%20stylish%20modern%20casual%20outfits%2C%20authentic%20happy%20expressions%2C%20minimalist%20composition%2C%20neutral%20warm%20tones&width=600&height=800&seq=test-photo-full-v2&orientation=portrait"
              alt="Zadowoleni klienci"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
            <div className="absolute bottom-0 left-0 p-5">
              <p className="text-white font-semibold text-sm whitespace-nowrap">Ponad 500+ zadowolonych użytkowników</p>
              <p className="text-white/70 text-xs mt-1">Kakobuy Spreadsheet</p>
            </div>
          </div>

          {reviews.slice(3, 5).map((review) => (
            <div
              key={review.nameKey}
              className="md:col-span-2 p-5 md:p-6 rounded-lg bg-background-100 border border-background-200/70 flex flex-col md:flex-row gap-4"
            >
              <div className="flex items-start gap-3 flex-shrink-0">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={review.img}
                    alt={t(review.nameKey)}
                    className="w-full h-full object-cover"
                  />
                </div>
                <p className="text-sm font-semibold text-foreground-900 md:hidden whitespace-nowrap">
                  {t(review.nameKey)}
                </p>
              </div>
              <div className="flex-1">
                <p className="hidden md:block text-sm font-semibold text-foreground-900 mb-1 whitespace-nowrap">
                  {t(review.nameKey)}
                </p>
                <i className="ri-double-quotes-l text-accent-300 text-xl mb-2 block"></i>
                <p className="text-foreground-600 text-sm leading-relaxed">
                  {t(review.textKey)}
                </p>
              </div>
            </div>
          ))}

          <div className="p-5 md:p-6 rounded-lg bg-background-100 border border-background-200/70">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                <img
                  src={reviews[2].img}
                  alt={t(reviews[2].nameKey)}
                  className="w-full h-full object-cover"
                />
              </div>
              <p className="text-sm font-semibold text-foreground-900 whitespace-nowrap">
                {t(reviews[2].nameKey)}
              </p>
            </div>
            <i className="ri-double-quotes-l text-accent-300 text-xl mb-2 block"></i>
            <p className="text-foreground-600 text-sm leading-relaxed">
              {t(reviews[2].textKey)}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}